import { LocalStorageKeys } from "@/components/pages/login/hooks/useLocalStorage";
import { useSyncExternalStore } from "react";

const HOTEL_SELECTION_EVENT = "guesteria:selected-hotel-change";

const emitHotelSelectionChange = (): void => {
  window.dispatchEvent(new Event(HOTEL_SELECTION_EVENT));
};

const subscribeToHotelSelection = (listener: () => void): (() => void) => {
  const handleHotelSelectionChange = () => {
    listener();
  };

  window.addEventListener(HOTEL_SELECTION_EVENT, handleHotelSelectionChange);
  window.addEventListener("storage", handleHotelSelectionChange);

  return () => {
    window.removeEventListener(
      HOTEL_SELECTION_EVENT,
      handleHotelSelectionChange,
    );
    window.removeEventListener("storage", handleHotelSelectionChange);
  };
};

export const getSelectedHotelId = (): string | null => {
  const hotelId = localStorage.getItem(LocalStorageKeys.HOTEL_ID);

  if (!hotelId) {
    return null;
  }

  const normalizedHotelId = hotelId.trim();
  return normalizedHotelId.length > 0 ? normalizedHotelId : null;
};

export const setSelectedHotelId = (hotelId: string | null): void => {
  if (!hotelId) {
    localStorage.removeItem(LocalStorageKeys.HOTEL_ID);
    emitHotelSelectionChange();
    return;
  }

  const normalizedHotelId = hotelId.trim();

  if (normalizedHotelId.length === 0) {
    localStorage.removeItem(LocalStorageKeys.HOTEL_ID);
    emitHotelSelectionChange();
    return;
  }

  localStorage.setItem(LocalStorageKeys.HOTEL_ID, normalizedHotelId);
  emitHotelSelectionChange();
};

export const useSelectedHotelId = (): string | null =>
  useSyncExternalStore(
    subscribeToHotelSelection,
    getSelectedHotelId,
    getSelectedHotelId,
  );
